import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { RoleSpecificAreaGroupsBlock } from '../../_blocks/RoleSpecificAreaGroups/RoleSpecificAreaGroupsBlock';
import { OverallAreaGroupsBlock } from '../../_blocks/OverallAreaGroups/OverallAreaGroupsBlock';

export type AreaGroupsWidget = ContextWidget<
  RoleSpecificAreaGroupsBlock | OverallAreaGroupsBlock,
  WidgetType.areagroups
>;

export function AreaGroupsWidget(props: AreaGroupsWidget) {
  const { t } = useSonTranslation('AreaGroups');
  return <DefaultContextWidget icon={Icons.TEAMROOM_PEOPLE} title={t('widgetTitle')} {...props} />;
}
